<div class="wrapper wrap">
  <div class="container">
    <div class="">
      <div class="">
        <h1 class="pageTitle">{{ pageTitle }}</h1>
        <app-notifications [notification]="'locations_page_notification_banner_parent'"></app-notifications>
        <div class="plain-text">{{ guidanceMsg }}</div>
      </div>
    </div>

    <div class="card-row mobile-table">
      <div class="location-card" *ngFor="let location of childrenDepartments; let i = index">
        <div class="card bg-light mb-4 column" (click)="selectDepartment(location)" routerLink="/services"
          tabindex="-1">
          <div class="card-location-header">
            <h2 class="text-dark">
              <strong>{{ location.name }}</strong>
            </h2>
          </div>
          <p class="mt-2" *ngIf="location?.address">
            <span *ngIf="location?.address.address1">{{ location.address.address1 }}, <br /></span>
            <span *ngIf="location?.address.address2">{{ location.address.address2 }}, <br /></span>
            <span *ngIf="location?.address.address3">{{ location.address.address3 }}, <br /></span>
            <span *ngIf="location?.address.address4">{{ location.address.address4 }}, <br /></span>
            <span *ngIf="location?.address.address5">{{ location.address.address5 }}, <br /></span>
            <span *ngIf="location?.address.postcode">{{ location.address.postcode }} <br /></span>
          </p>

          <div class="bottom">
            <button tabindex="0" class="btn btn-primary button-fill" title="Select {{ location.name }}"
              attr.aria-label="Select {{ location.name }}">
              <span><span aria-hidden="true">Select</span><fa-icon [icon]="faChevronRight"></fa-icon></span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card-row desktop-table">
      <div class="table-row" *ngFor="let row of childRows; let i = index">
        <div *ngFor="let location of row; let i = index" class="location-card">
          <div (click)="selectDepartment(location)" routerLink="/services" tabindex="-1" class="card bg-light column"
            [ngClass]="{ inheritWidth: row.length === 2 }">
            <div class="card-location-header">
              <h2 class="text-dark">
                <strong>{{ location.name }}</strong>
              </h2>
            </div>
            <p class="mt-2" *ngIf="location?.address" id="{{ location.id }}">
              <span *ngIf="location?.address.address1">{{ location.address.address1 }}, <br /></span>
              <span *ngIf="location?.address.address2">{{ location.address.address2 }}, <br /></span>
              <span *ngIf="location?.address.address3">{{ location.address.address3 }}, <br /></span>
              <span *ngIf="location?.address.address4">{{ location.address.address4 }}, <br /></span>
              <span *ngIf="location?.address.address5">{{ location.address.address5 }}, <br /></span>
              <span *ngIf="location?.address.postcode">{{ location.address.postcode }} <br /></span>
            </p>

            <div class="bottom">
              <button tabindex="0" class="btn btn-primary button-fill" title="Select {{ location.name }}"
                attr.aria-label="Select {{ location.name }}">
                <span><span aria-hidden="true">Select</span><fa-icon [icon]="faChevronRight"></fa-icon></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4" *ngIf="!this.member">
      <div class="col-6">
        <button type="button" class="btn btn-primary govuk-button button-sizer" (click)="routerGoBack()" title="Back"
          aria-label="Back to location"><span>
          <fa-icon [icon]="faChevronLeft"></fa-icon><span>{{ 'COMMON.BACK' | translate }}</span>
          </span></button>
      </div>

    </div>
    <br *ngIf="!this.member">
  </div>
</div>